import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnAllowOnlyAdminImplementationManager,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import InsightConfigList from './pages/list/index';
import InsightConfigMaintenance from './pages/upsert/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import InsightConfigFormStore from './store/index';
import InsightConfigListStore from './store/list';

const Pages = ProtectedRoute => ({
  InsightConfigEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      Component={InsightConfigMaintenance}
      componentProps={{ action: FORM_ACTION.EDIT }}
    />
  ),
  InsightConfigCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlyAdminImplementationManager],
      }}
      Component={InsightConfigMaintenance}
      componentProps={{ action: FORM_ACTION.CREATE }}
    />
  ),
  InsightConfigList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={InsightConfigList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    insightConfigFormStore: new InsightConfigFormStore(rootStore),
    insightConfigListStore: new InsightConfigListStore(rootStore),
  },
];

export { InsightConfigList, InsightConfigMaintenance, routes, stores };
